import { Box, Button, FormControl, InputLabel, TextField, Typography } from "@mui/material";
import _ from "lodash";
import React from "react";
import SimpleDialog from "../common/SimpleDialog";
import { Filter } from "./FilterTypes";
import { SelectOption } from 'src/types/common'
import { getAllUsersEndpoint, getUsersEndpoint, shareFilterEndpoint } from "../../configs/endpoints";
import { client } from "../../utils/axios-client";
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem';
import { ApiResponseType } from "../../types";
import ApplicationStore from "../../stores/ApplicationStore";

type Props = {
    open: boolean,
    onClose: () => void,
    filter: Filter
}

const ShareFilterDialog = ({ filter, open, onClose }: Props) => {
    const [userError, setUserError] = React.useState(false);
    const [nameError, setNameError] = React.useState(false);
    const [selectedUser, setSelectedUser] = React.useState('');
    const [users, setUsers] = React.useState([] as SelectOption[])
    const [shareFilterName, setShareFilterName] = React.useState('');

    React.useEffect(() => {
        setUserError(false);

        loadUsers();
    }, [open]);

    React.useEffect(() => {
        setShareFilterName(filter.description);
    }, [filter])

    const loadUsers = async () => {
        const response = await client.get(getAllUsersEndpoint);

        setUsers(response.data);
    }

    const onShare = async () => {
        setUserError(false);
        setNameError(false);

        let error = false;

        if (_.isEmpty(selectedUser)) {
            setUserError(true)
            error = true;
        }

        if (_.isEmpty(shareFilterName)) {
            setNameError(true)
            error = true;
        }

        if (error) return;

        const response = await client.post<ApiResponseType>(shareFilterEndpoint, { ...filter, userId: selectedUser, description: shareFilterName });

        if (response.data.succeeded) {
            ApplicationStore.update(s => {
                s.snackbarOpen = true;
                s.snackbarMessage = "Filter Shared";
            });

            onClose();
        } else {
            ApplicationStore.update(s => {
                s.snackbarOpen = true;
                s.snackbarMessage = "There was an issue sharing the filter. Please try again.";
            });
        }
    }

    return (
        <SimpleDialog title='Share Filter' open={open} onClose={() => onClose()} size='sm' sx={{ padding: 5, pt: 2 }} fullHeight={false}>
            <FormControl fullWidth sx={{ mb: 10 }}>
                <TextField label="Filter Name" value={shareFilterName} onChange={(e => setShareFilterName(e.target.value))} />
            </FormControl>

            {nameError && <Box sx={{ color: 'red' }}>You must specify a name for the filter.</Box>}

            <FormControl fullWidth>
                <InputLabel>User</InputLabel>
                <Select label="User" error={userError} value={selectedUser} onChange={(e) => setSelectedUser(e.target.value)}>
                    {users.map(user => <MenuItem key={user.value} value={user.value}>{user.name}</MenuItem>)}
                </Select>

            </FormControl>

            {userError && <Box sx={{ color: 'red' }}>You must select a user to share the filter with.</Box>}

            <Box sx={{ pt: 10, textAlign: 'right' }}>
                <Button onClick={() => onShare()}>Share</Button>
                <Button onClick={() => onClose()}>Cancel</Button>
            </Box>
        </SimpleDialog>
    )
}

export { ShareFilterDialog }
export default ShareFilterDialog;